/**
 * Cache Service exports
 */

export { GsbCacheService } from './gsb-cache.service';

// Convenience singleton instance
import { GsbCacheService } from './gsb-cache.service';

// Default export is the singleton instance
export default GsbCacheService.getInstance(); 